import { AiFillCloseCircle } from "react-icons/ai";
import { useAdmin } from "../../../../context/admin";
import AdminService from "../../../../services/admin.service";
import Modal from "../../../common/Modal";
import { useGlobal } from "../../../../context/global";

export default function ConfirmDeleteCost() {
    const { setIsLoading } = useGlobal()
    const { confirmDeleteCostId, setConfirmDeleteCostId } = useAdmin()

    async function onDelete(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault()
        setIsLoading(true)
        try {
            await AdminService.deleteCost(confirmDeleteCostId!)
            window.location.reload()
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false)
        }
    }
    return (
        <Modal onSubmit={onDelete}>
            <h1>Confirm delete cost</h1>
            <p>Are you sure you want to delete this cost? This action cannot be undone.</p>
            <div className="actions" 
            style={{ margin: '15px 0'}}
            >
                <button className="delete">Delete</button>
            </div>
            <div className="close" onClick={() => setConfirmDeleteCostId(undefined)}>
                <AiFillCloseCircle />
            </div>
        </Modal>
    )
}